import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Terrace = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="terrace"
      width={width}
      height={height}
      stroke={stroke}
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)" fill={fill}>
        <path d="M5.81 54.844c.73.363 1.605.064 1.966-.655l4.549-9.098 4.549 9.098a1.466 1.466 0 002.62-1.31l-4.799-9.599h3.489c.809 0 1.465-.655 1.465-1.465 0-7.28-5.903-13.183-13.184-13.183-.808 0-1.465.656-1.465 1.465v11.718c0 .81.657 1.465 1.465 1.465h3.49l-4.8 9.599a1.465 1.465 0 00.655 1.965zM8.18 14.54a1.467 1.467 0 00.563 2.123 14.631 14.631 0 0010.994.825 8.384 8.384 0 01-.067-1.626c.291-4.241 3.65-8.348 6.267-10.862h-.12c-7.107 0-13.7 3.628-17.638 9.54zM29.977 5.416c-2.053 1.688-7.087 6.273-7.384 10.65-.032.466.003.914.083 1.35l2.622.873c1.018.34 2.173.52 3.237.626v15.576H20.8a15.977 15.977 0 011.705 5.86h6.031v11.718h-4.492a1.464 1.464 0 100 2.93h11.914a1.464 1.464 0 100-2.93h-4.492V40.351h6.03c.19-2.096.788-4.071 1.705-5.86h-7.735V18.915c1.064-.107 2.22-.286 3.237-.625l2.646-.883c.704-4.527-5.136-10.068-7.37-11.991zM51.26 16.662a1.464 1.464 0 00.564-2.123C47.883 8.627 41.287 5 34.184 5h-.213c2.927 2.869 6.843 7.77 6.323 12.5a14.656 14.656 0 0010.966-.838zM53.535 28.632c-7.281 0-13.184 5.902-13.184 13.183 0 .81.656 1.465 1.465 1.465h3.49l-4.8 9.599a1.465 1.465 0 002.62 1.31l4.55-9.098 4.548 9.098a1.466 1.466 0 002.621-1.31l-4.8-9.599h3.49c.808 0 1.465-.655 1.465-1.465V30.098c0-.81-.657-1.465-1.465-1.465z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" transform="translate(5 5)" d="M0 0h50v50H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Terrace.defaultProps = {
  className: null,
};

Terrace.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Terrace;
